export enum AppRightSidebarTab {
  Guidance = 'guidance',
  Chat = 'chat'
}
